@use "../../HeaderNav/Header.module.scss" as *;
@use "../../../styles/breakpoint.module.scss" as *;

.root {
    composes: safeGridContainer from "../../../styles/composable/layout.module.css";
    height: calc(100dvh - #{$main-nav-height});
    padding-block: var(--spacer-80);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    text-align: center;
    align-content: start;
}

.heading {
    grid-column: 1 / -1;
    font: var(--font-h-64);
}

.body {
    grid-column: 3 / span 8;
    font: var(--font-p-18);
    text-wrap: pretty;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.ctaContainer {
    grid-column: 1 / -1;
}

.snapshot {
    grid-column: 1 / -1;
    margin-block: var(--spacer-40);
}

.dialogTrigger {
    font: var(--font-text-link-14);
    text-decoration: underline;
}
